module.exports = function () {
  const mailtoLinks = document.querySelectorAll('.safer-mailto');
  mailtoLinks.forEach(link => {
    const email = link.innerHTML;
    const safeEmail = email.replace(/\s*\(.+\)\s*/, "@");

    link.setAttribute('href', `mailto:${safeEmail}`);
    link.innerHTML = safeEmail;

  });
}
